import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408c8fe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row fixed top-0 w-full shadow h-16 bg-secondary" }
const _hoisted_2 = { class: "fixed top-16 left-0 h-full flex flex-row w-full" }
const _hoisted_3 = { class: "flex flex-col w-16 bg-primary flex-shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "edit-pane"
}
const _hoisted_5 = { class: "truncate col-span-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createTextVNode(" Type: "),
  /*#__PURE__*/_createElementVNode("select", { disabled: "" }, [
    /*#__PURE__*/_createElementVNode("option", null, "Multiple choice")
  ])
], -1))
const _hoisted_7 = {
  key: 1,
  class: "edit-pane"
}
const _hoisted_8 = { class: "grid grid-cols-2 gap-2 p-3 pt-0" }
const _hoisted_9 = {
  key: 2,
  class: "edit-pane"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Form Level:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Question Level:", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "edit-pane"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "gerverfref", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserNavVue = _resolveComponent("UserNavVue")!
  const _component_TextInputWithErrorVue = _resolveComponent("TextInputWithErrorVue")!
  const _component_SolidButtonVue = _resolveComponent("SolidButtonVue")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FormPageVue = _resolveComponent("FormPageVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UserNavVue, { class: "text-primary my-3 mx-10" }),
      _createVNode(_component_TextInputWithErrorVue, {
        modelValue: _ctx.getBranch.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getBranch.code) = $event)),
        "is-error": !_ctx.getBranch.code,
        class: "self-center text-monospace"
      }, null, 8, ["modelValue", "is-error"]),
      _createElementVNode("div", {
        class: "content-center mx-10 my-3 w-32",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.PublishForm()))
      }, [
        (_ctx.isPublishing)
          ? (_openBlock(), _createBlock(_component_SolidButtonVue, {
              key: 0,
              text: 'publishing',
              icon: 'snowflake',
              "icon-type": 'far',
              "icon-meta": 'fa-spin',
              class: "w-24",
              "is-selected": true
            }))
          : (_openBlock(), _createBlock(_component_SolidButtonVue, {
              key: 1,
              text: 'publish',
              class: "w-24"
            }))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['far', 'snowflake'],
          class: "edit-pane-nav-icons",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleEditPaneMode('scene')))
        }),
        _createVNode(_component_font_awesome_icon, {
          icon: ['far', 'clone'],
          class: "edit-pane-nav-icons",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleEditPaneMode('graph')))
        })
      ]),
      (_ctx.show.editPane === 'scene')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEls, (el) => {
              return (_openBlock(), _createElementBlock("div", {
                key: el.id,
                class: "p-2 grid grid-cols-4 grid-rows-3 rounded-lg bg-white shadow-sm"
              }, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(el.title), 1),
                _hoisted_6,
                (_ctx.getScene?.elements.find((o) => o.id == el.id)?.row != 0)
                  ? (_openBlock(), _createBlock(_component_SolidButtonVue, {
                      key: 0,
                      icon: 'chevron-up',
                      "icon-type": 'fas',
                      onClick: ($event: any) => (
            _ctx.moveEl(
              (_ctx.getScene?.elements.find((o) => o.id == el.id)?.row || 0) - 1,
              _ctx.getScene?.elements.find((o) => o.id == el.id)?.row || 0
            )
          )
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
            _ctx.getScene?.elements.find((o) => o.id == el.id)?.row !=
            _ctx.getEls.length - 1
          )
                  ? (_openBlock(), _createBlock(_component_SolidButtonVue, {
                      key: 1,
                      icon: 'chevron-down',
                      "icon-type": 'fas',
                      onClick: ($event: any) => (
            _ctx.moveEl(
              (_ctx.getScene?.elements.find((o) => o.id == el.id)?.row || 0) + 1,
              _ctx.getScene?.elements.find((o) => o.id == el.id)?.row || 0
            )
          )
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.getEls.length > 1)
              ? (_openBlock(), _createBlock(_component_SolidButtonVue, {
                  key: 0,
                  icon: 'trash-alt',
                  "icon-type": 'far',
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.delEl()))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_SolidButtonVue, {
              icon: 'plus',
              "icon-type": 'fas',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addEl()))
            })
          ]))
        : (_ctx.show.editPane === 'graph')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SolidButtonVue, {
                  icon: 'plus',
                  "icon-type": 'fas'
                })
              ])
            ]))
          : (_ctx.show.editPane === 'style')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : (_ctx.show.editPane === 'setting')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
      _createVNode(_component_FormPageVue, {
        els: _ctx.getEls,
        branch: _ctx.getBranch,
        "in-edit-mode": true
      }, null, 8, ["els", "branch"])
    ])
  ], 64))
}